module.exports = {
    /**
     * 打开新的webView<br />
     * 使用场景：搞SPA的话native导航栏没法跟h5实现同步的动画效果，故此处将定义导航栏的API加入新开webView的API中，由调用新webView者决定下一页的导航栏样式。<br />
     * 对应native接口：webview.open
     * @method hysdk.openWebView
     * @category WebView
     * @example ./openWebView.js[1-53]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   √  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     * 请求参数说明：
     * <table style="text-align:center">
     *     <tr>
     *         <th width="100">参数</th>
     *         <th width="80">类型</th>
     *         <th width="220">说明</th>
     *         <th width="80">iOS</th>
     *         <th width="80">Android</th>
     *         <th width="80">touch</th>
     *         <th width="80">wechat</th>
     *     </tr>
     *     <tr>
     *         <td>url</td>
     *         <td rowspan="2">string</td>
     *         <td>webview的url地址</td>
     *         <td rowspan="6">√</td>
     *         <td rowspan="6">√</td>
     *         <td rowspan="6">X</td>
     *         <td rowspan="6">X</td>
     *     </tr>
     *     <tr>
     *         <td>name</td>
     *         <td>view的名字</td>
     *     </tr>
     *     <tr>
     *         <td>data</td>
     *         <td>object</td>
     *         <td>view通信数据，子view通过getInitData获取</td>
     *     </tr>
     *     <tr>
     *         <td>animate</td>
     *         <td>string</td>
     *         <td style="text-align:left">新页面进入的方式，可选<br/>缺省值为moveFromRight<br/>也可为moveFromBottom</td>
     *     </tr>
     *     <tr>
     *         <td>type</td>
     *         <td>string</td>
     *         <td style="text-align:left">navibar的类型<br/>缺省值为navibar-normal<br/>也可为navibar-transparent (透明的navibar)、navibar-none (没有navibar)</td>
     *     </tr>
     *     <tr>
     *         <td>navigation</td>
     *         <td>object</td>
     *         <td>navigation参数<br/><a href="http://ued.qunar.com/hy2/hysdk/appendix.html#normal导航栏选项">type为navibar-normal时</a>
     *             <br/><a href="http://ued.qunar.com/hy2/hysdk/appendix.html#transparent导航栏选项">type为navibar-transparent时</a></td>
     *     </tr>
     * </table>
     * **注意：**h5环境下，即为window.open方法，传参数改成传对象格式的参数，对应url, name和features，参考示例和<a href="https://developer.mozilla.org/en-US/docs/Web/API/Window/open" target="_blank">mdn文档</a>
     */
    openWebView: {
        hy: {
            key: 'webview.open',
            hooks: function hooks() {
                var sdk = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                var isFunction = function isFunction(func) {
                    return typeof func === 'function';
                };
                options.isOff && isFunction(sdk.offReceiveData) && sdk.offReceiveData();
                isFunction(sdk.onceReceiveData) && sdk.onceReceiveData({
                    success: isFunction(options.onViewBack) ? options.onViewBack : function () {}
                });
            }
        },
        h5: {
            handle: function handle(options) {
                var url = options.url,
                    name = options.name,
                    features = options.features;

                window.open(url, name, features);
            }
        }
    },
    /**
     * 关闭当前view<br />
     * 使用场景：用户进行操作后，直接关闭view的接口。可传递数据<br />
     * 对应native接口：webview.back
     * @method hysdk.closeWebView
     * @category WebView
     * @example ./closeWebView.js[1-9]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     */
    closeWebView: {
        hy: {
            key: 'webview.back'
        }
    },
    /**
     * 设置当前view的属性<br />
     * 使用场景：用户需要改变当前view的展示属性时<br />
     * 对应native接口：webview.attribute
     * @method hysdk.setWebViewAttr
     * @category WebView
     * @example ./setWebViewAttr.js[1-10]
     * @description
     *
     * <table style="text-align:center">
     * <tr>
     *    <th width="100">参数</th>
     *    <th width="80">类型</th>
     *    <th width="220">说明</th>
     *    <th width="80">iOS</th>
     *    <th width="80">Android</th>
     *    <th width="80">touch</th>
     *    <th width="80">wechat</th>
     *    <th width="80">支持版本</th>
     * </tr>
     * <tr>
     *    <td>scrollEnabled</td>
     *    <td>bool</td>
     *    <td>是否允许native的webview支持滚动，默认值是true</td>
     *    <td rowspan="4">√</td>
     *    <td rowspan="2">X</td>
     *    <td rowspan="4">X</td>
     *    <td rowspan="4">X</td>
     *    <td rowspan="3">一直支持</td>
     * </tr>
     * <tr>
     *    <td>backgroundColor</td>
     *    <td>string</td>
     *    <td> iOS滑动出document区域，展示出的背景颜色， 值的形式'#fff'</td>
     * </tr>
     *    <tr>
     *    <td>name</td>
     *    <td>string</td>
     *    <td>webview的name，必须要保证唯一，否则路由会乱</td>
     *    <td>√</td>
     * </tr>
     * <tr>
     *    <td>bounces</td>
     *    <td>bool</td>
     *    <td>webview的弹性效果，默认值为true。当scrollEnabled为false时，由于不支持滚动，所以这个值无效</td>
     *    <td>X</td>
     *    <td>iOS: 版本号4.10.5, vid 80011129</td>
     * </tr>
     * </table>
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     */
    setWebViewAttr: {
        hy: {
            key: 'webview.attribute'
        }
    },
    /**
     * 获取初始化数据<br />
     * 使用场景：由父级view打开的view，获取父view传递的数据<br />
     * 对应native接口：webview.getInitData
     * @method hysdk.getInitData
     * @category WebView
     * @example ./getInitData.js[1-10]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    getInitData: {
        hy: {
            key: 'webview.getInitData'
        }
    },
    /**
     * 设置状态栏颜色<br />
     * 使用场景：希望修改状态栏颜色，比如页面是黑色，希望设置状态栏颜色为白色<br />
     * 对应native接口：qunarnative.status
     * @method hysdk.setStatus
     * @category WebView
     * @example ./setStatus.js[1-13]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     */
    setStatus: {
        hy: {
            key: 'qunarnative.status'
        }
    },
    /**
     * 设置webview是否支持ios的后退手势<br />
     * 使用场景：需要单独开启或关闭ios的后退手势时<br />
     * 对应native接口：qunarnative.gesturesView
     * @method hysdk.enableBackGesture
     * @category WebView
     * @example ./enableBackGesture.js[1-5]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √(IOS)   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     */
    enableBackGesture: {
        hy: {
            key: 'qunarnative.gesturesView'
        }
    },
    /**
     * 隐藏 Loading 页面<br />
     * 对应native接口：webview.hideLoadView
     * @method hysdk.hideLoadView
     * @category WebView
     * @example
     * hysdk.hideLoadView({})
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     */
    hideLoadView: {
        hy: {
            key: 'webview.hideLoadView'
        }
    },
    /**
     * 获取 View History<br />
     * 对应native接口：view.list
     * @method hysdk.getHistory
     * @category WebView
     * @example ./getHistory.js[1-7]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    getHistory: {
        hy: {
            key: 'view.list'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/apis/webview.js
// module id = 18
// module chunks = 0 2 4